import { FeBundleRepository } from "containers/BundleRepositories/types";

export const getBundleRepositoriesList = (state) =>
    (state.bundleRepositories.list ?? []) as FeBundleRepository[];
